/*
 * Copyright 2022, Corning Optical Communications
 * All Rights Reserved.
 */
import React from "react";
import { useSelector } from "react-redux";
import { setScheduledTask } from "../../../store/api/tasks/reducer";
import { tasksSelector } from "../../../store/api/tasks/selector";
import { setErrorMsg } from "../../../store/helpers/helperReducers";
import { errorMsgSelector } from "../../../store/helpers/helperSelectors";
import { useStoreDispatch } from "../../../store/hooks";
import CheckboxLabel from "../../Shared/CheckBox/CheckboxLabel";
import { InputField } from "../../Shared/Radix/Inputs/InputField";


export const LTERemStart: React.FC = () => {
    const dispatch = useStoreDispatch();

    const errorMsg = useSelector(errorMsgSelector);
    const scheduledtasks = useSelector(tasksSelector);


    const onChangeHandler = (name: string, value: string) => {
        dispatch(setScheduledTask({ [name]: value }));
        dispatch(setErrorMsg({ [name]: "" }));
    };
    const checkboxHandler = (event: any) => {
        const { checked } = event?.target;
        dispatch(setScheduledTask({ referenceSinglePowerEnabled: checked ? "true" : "false" }));
    };

    return (
        <div className="flex flex-col gap-5">
            <div>
                <InputField
                    label="Zones"
                    name="zoneIdValue"
                    value={scheduledtasks?.zoneIdValue ?? ""}
                    onChange={onChangeHandler}
                    placeholder="Enter zone"
                />
                {!errorMsg?.zoneIdValue && (
                    <p className="text-xs text-muted-foreground mt-4">
                        List of Zones- eg 0,1,2 - if not specified, REM is executed on Zone 0
                    </p>
                )}
            </div>
            <div>
                <CheckboxLabel
                    label="Reference Single Power Enabled"
                    checked={scheduledtasks?.referenceSinglePowerEnabled === "true"}
                    name="referenceSinglePowerEnabled"
                    onChange={checkboxHandler} />
            </div>
        </div>
    )
}